import "./case-study-hero.scss";
